document.addEventListener("DOMContentLoaded", function () {
  const permaLinks = document.querySelectorAll(".checkout-permalink");
  permaLinks.forEach(function (permaLink) {
    permaLink.addEventListener("click", function (e) {
      e.preventDefault();
      let checkoutPermalink = this.getAttribute("href");
      let newCheckoutPermalink = "/checkout";
      let elems = checkoutPermalink.split("cart/")[1];
      let elemArr = elems.split("?")[0].split(",");

      if (checkoutPermalink.includes("?")) {
        newCheckoutPermalink =
          newCheckoutPermalink + checkoutPermalink.split("?")[1];
      }

      let formData = { items: [] };
      elemArr.forEach(function (elem) {
        let productId = elem.split(":")[0];
        let variantId = parseInt(productId.split("-")[0]);
        let firmHouseId = parseInt(productId.split("-")[1]);
        let qty = parseInt(elem.split(":")[1]);
        let item = {
          id: variantId,
          quantity: qty,
          properties: {
            _firmhouseids: firmHouseId.toString(),
            _intervalunitofmeasure: "default",
            _interval: "0",
          },
        };
        formData.items.push(item);
      });

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log(data); // Handle the response data
          window.location.assign(newCheckoutPermalink);
        })
        .catch((error) => {
          console.error("Error:", error);
          window.location.assign(newCheckoutPermalink);
        });
    });
  });
});
